/**
 * TanStack Query hooks for `publisher-dashboard-separate-persona-with-partner`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	publisherDashboardSeparatePersonaWithPartnerQueryKeys,
	type CreatePublisherDashboardSeparatePersonaWithPartnerBody,
	type ListPublisherDashboardSeparatePersonaWithPartnerResponse,
	type PublisherDashboardSeparatePersonaWithPartnerRow,
} from "./api";

export function usePublisherDashboardSeparatePersonaWithPartnerList(): UseQueryResult<ListPublisherDashboardSeparatePersonaWithPartnerResponse, Error> {
	return useQuery({
		queryKey: publisherDashboardSeparatePersonaWithPartnerQueryKeys.list(),
		queryFn: list,
	});
}

export function usePublisherDashboardSeparatePersonaWithPartnerCreate(): UseMutationResult<PublisherDashboardSeparatePersonaWithPartnerRow, Error, CreatePublisherDashboardSeparatePersonaWithPartnerBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: publisherDashboardSeparatePersonaWithPartnerQueryKeys.all });
		},
	});
}

export function usePublisherDashboardSeparatePersonaWithPartnerDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: publisherDashboardSeparatePersonaWithPartnerQueryKeys.all });
		},
	});
}
